import DisplayFilesByCategoryTrigger from './DisplayFilesByCategoryTrigger.component';

export default DisplayFilesByCategoryTrigger;